import { useEffect } from "react";
import { useBullBoardRedirect } from "@/api/queues";
import { Loader2 } from "lucide-react";

export function QueuesRedirectScreen() {
  const { openBullBoard, error } = useBullBoardRedirect();

  useEffect(() => {
    void openBullBoard();
  }, []);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-full gap-4">
        <p className="text-red-500">Failed to open queues dashboard</p>
        <p className="text-sm text-muted-foreground">{error.message}</p>
        <button
          onClick={openBullBoard}
          className="px-4 py-2 bg-primary text-primary-foreground rounded-md"
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-full gap-4">
      <Loader2 className="h-8 w-8 animate-spin" />
      <p className="text-muted-foreground">Opening job queues dashboard...</p>
    </div>
  );
}
